import React from "react";
import { Checkbox } from "../../atoms";

const renderCheckboxOptions = props => {
	const { options, checks, changeAction } = props;
	
	return options.map(o =>
		<Checkbox
			key={o.id}
			id={o.id}
			label={o.label}
			checked={[...checks].indexOf(o.id) > -1}
			changeAction={changeAction}
		/>
	);
};

export const CheckboxMolecule = props => {
	return (
		<div className="checkbox-molecule">
			<label>{props.label}</label>
			{renderCheckboxOptions(props)}
		</div>
	);
};


// WEBPACK FOOTER //
// src/molecules/lib/CheckboxMolecule.js